// General
import "./info-notification.scss";
// Material UI
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloseIcon from "@mui/icons-material/Close";

const InfoNotification = (props) => {
  const { message } = props;

  return (
    <div id="info-notification-element">
      <div className="padding-container">
        <div className="center-container">
          <div className="info-icon-container">
            <div className="info-inner-ring">
              <AccessTimeIcon className="info-icon" />
            </div>
          </div>
        </div>

        <div className="message-body-container">
          <div className="message-body">{message}</div>
        </div>

        {false && (
          <div className="close-icon-container">
            <CloseIcon className="close-icon" />
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoNotification;
